import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';
import { formatPercent, USD } from 'helpers/formatters/number_formats';

import './styles.scss';

export function compDetails(comp) {
  if (comp.type === 'Research::Sale') {
    const details = [USD.format(comp.price, { round: true }), comp.buildingSizeLabel];
    if (comp.saleDate) details.push(`Sold ${comp.saleDate}`);
    if (comp.capRatePct != null) details.push(`Cap: ${formatPercent(comp.capRatePct / 100)}`);
    return details;
  }

  const details = [comp.leaseRateLabel, comp.sizeLabel];
  if (comp.leaseDate) details.push(`Leased ${comp.leaseDate}`);
  return details;
}

export function getCompEditUrl(editCompPath) {
  const returnTo = encodeURI(window.location.href);
  const editCompUrl = new URL(editCompPath, window.location.origin);
  editCompUrl.searchParams.set('return_to', returnTo);

  return editCompUrl.toString();
}

export default function CompRow({ children, comp, connectDragSource, selected, onDeselect, onSelect }) {
  const selectable = onDeselect && onSelect;
  function handleClick() {
    if (selectable) {
      selected ? onDeselect(comp) : onSelect(comp);
    }
  }

  return (
    <div className={classNames('comp-row p-3', { clickable: selectable })} onClick={handleClick}>
      <div className="row">
        <div className="col col-4 col-sm-6 d-flex align-items-center">
          {connectDragSource && connectDragSource(
            <span className="drag-handle px-2 text-muted clickable">
              <FontAwesomeIcon icon={faEllipsisV}/>
            </span>
          )}
          {selectable && <ManagedInput checked={selected} className="me-3" type="checkbox" />}
          <img className="d-none d-lg-block me-3" src={comp.photoUrl} />
          <div className="section text-muted">
            <div>{comp.displayName}</div>
            <div>{comp.displayName === comp.address ? comp.addressTwoLine[1] : comp.addressOneLine}</div>
            <div>{comp.propertyType}</div>
          </div>
        </div>

        <div className="col col-8 col-sm-6 d-flex align-items-center">
          <div className="section flex-fill d-none d-md-block text-muted">
            {compDetails(comp).map((detail, index) => <div key={index}>{detail}</div>)}
          </div>

          <div className="flex-grow text-end">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

CompRow.propTypes = {
  children: PropTypes.node,
  comp: PropTypes.shape({
    address: PropTypes.string,
    addressOneLine: PropTypes.string,
    addressTwoLine: PropTypes.arrayOf(PropTypes.string).isRequired,
    buildingSizeLabel: PropTypes.string,
    capRatePct: PropTypes.number,
    displayName: PropTypes.string,
    leaseDate: PropTypes.string,
    leaseRateLabel: PropTypes.string,
    photoUrl: PropTypes.string,
    price: PropTypes.number,
    propertyType: PropTypes.string,
    saleDate: PropTypes.string,
    sizeLabel: PropTypes.string,
  }).isRequired,
  connectDragSource: PropTypes.func,
  selected: PropTypes.bool,
  onDeselect: PropTypes.func,
  onSelect: PropTypes.func,
};
